// img object-fit - support for IE11
window.enfc.fn.objectFitSupport('.cta-panel__figure');
